import { useEffect } from 'react';

import { useFilters } from '../../providers/FiltersProvider';
import { useMediaQuery } from '../../hooks/useMediaQuery';

import ClearAllLink from './shared/ClearAllLink';
import ContentTypeFilter from './ContentTypeFilter';
import TopicsFilter from './TopicsFilter';

interface FiltersContainerProps {
  showContentTypeFilter?: boolean;
  showTopicsFilter?: boolean;
}

const FiltersContainer = ({
  showContentTypeFilter = true,
  showTopicsFilter = true,
}: FiltersContainerProps) => {
  const isMobile = useMediaQuery('(max-width: 1023px)');
  const { clearAllFilters, showFilters, setShowFilters, totalSelected } =
    useFilters();

  useEffect(() => {
    clearAllFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const displayClass = showFilters ? 'block' : 'hidden';

  const mobileClasses = isMobile
    ? 'bg-white mt-[12px] p-[23px] rounded-[8px] shadow-[0px_4px_4px_rgba(0,0,0,0.25)]'
    : 'py-[12px]';

  const clearAllJustification = showContentTypeFilter
    ? 'justify-between'
    : 'justify-end';

  useEffect(() => {
    setShowFilters(!isMobile);
  }, [isMobile, setShowFilters]);

  return (
    <div
      className={`w-full flex flex-col gap-[10px] lg:gap-[12px] ${displayClass} ${mobileClasses}`}
    >
      <div className={`flex flex-grow ${clearAllJustification} items-center`}>
        {showContentTypeFilter && <ContentTypeFilter />}
        {totalSelected > 0 && (
          <div className="hidden lg:block text-right">
            <ClearAllLink onClick={clearAllFilters} />
          </div>
        )}
      </div>
      {showTopicsFilter && <TopicsFilter />}
      <div className="flex lg:hidden mt-[21px] gap-[16px] items-center">
        <button
          className="bg-white border border-black px-[16px] py-[5px] rounded-[4px] font-bold text-[13px] leading-[18px] text-navy"
          onClick={() => setShowFilters(false)}
        >
          Done
        </button>
        {totalSelected > 0 && <ClearAllLink onClick={clearAllFilters} />}
      </div>
    </div>
  );
};
export default FiltersContainer;
